import { ThemeConfig, theme } from "antd";

type AppThemeConfig = Required<Pick<ThemeConfig, "token" | "algorithm">>;

export const graiaDefaultFont = `PublicSans, ${theme.defaultSeed.fontFamily}`;
export const graiaDefaultCodeFont = `Consolas, ${theme.defaultSeed.fontFamilyCode}`;
export const graiaPrimaryColor = "#353ea1";
export const graiaSuccessColor = "#23b964";
export const graiaWarningColor = "#f9a825";
export const graiaErrorColor = "#fa3232";
export const graiaInfoColor = "#23b9eb";
export const graiaWhiteColor = "#f0ece6";

const baseTokens: AppThemeConfig["token"] = {
  fontFamily: graiaDefaultFont,
  fontFamilyCode: graiaDefaultCodeFont,
  colorPrimary: graiaPrimaryColor,
  colorSuccess: graiaSuccessColor,
  colorWarning: graiaWarningColor,
  colorError: graiaErrorColor,
  colorInfo: graiaInfoColor,
};

const appTheme: AppThemeConfig = {
  token: {
    ...baseTokens,
  },
  algorithm: theme.defaultAlgorithm,
};

export default appTheme;
